export default {"src":"/_next/static/media/palmpay.cb8ce90c.svg","height":27,"width":86,"blurWidth":0,"blurHeight":0};